import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { resetPassword } from "../../services/Management/UserProfileService";

import defaultBg from "../../assets/backgrounds/bloom.jpg";
import defaultLogo from "../../assets/logos/Logo-Oasis.svg";
import Paths from "../../constants/Paths";

class ForgotPassword extends Component {
  state = {
    fieldValues: {
      email: "",
    },
    background: this.props.customBgImage || defaultBg,
    Done: false,
  };
  handleChange = (field, value) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [field]: value,
      },
    });
  };

  render() {
    const { _ } = this.props;

    return (
      <div
        className={
          "login-screen forgot-password" +
          (this.state.Done ? " reset-password" : "")
        }
      >
        <div className="login-screen-form-wrapper">
          {this.state.Done ? (
            <>
              <div className="reset-password-complete">
                <img
                  src={defaultLogo}
                  alt={_.Logo}
                  className="login-screen-logo"
                />
                <i className="icon-omni-tick-circle" />
                <h3>Password Reset Request Submitted</h3>
                <p className="my-3">
                  Please check your email for instructions.
                </p>
                <p>
                  <span onClick={() => this.props.history.push(Paths.Login)}>
                    Continue to Login
                  </span>
                </p>
                <p className="login-screen-footer-copyright">
                  {_.FooterCopyright}
                </p>
              </div>
            </>
          ) : (
            <>
              <img
                src={defaultLogo}
                alt={_.Logo}
                className="login-screen-logo"
              />
              <h3
                className={
                  this.props.User && this.props.User.invalidLogin
                    ? "dosent-exist"
                    : ""
                }
              >
                {_.PasswordReset}
              </h3>
              <form className="login-screen-form">
                <div className="form-group">
                  <label htmlFor="email">{_.EnterEmailAddress} *</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="omni-email-2" />
                      </div>
                    </div>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder={_.EnterEmailAddress}
                      value={this.state.fieldValues.email}
                      onChange={(e) =>
                        this.handleChange("email", e.target.value)
                      }
                      required={true}
                      autoComplete="username"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-themed form-control"
                  disabled={
                    !this.state.fieldValues.email.match(
                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    resetPassword({ email: this.state.fieldValues.email }).then(
                      () => {
                        this.setState({ Done: true });
                      }
                    );
                  }}
                >
                  {_.Confirm}
                </button>
              </form>
              <p className="login-screen-or">{_.Or}</p>
              <p className="cancel-link">
                <Link to={Paths.Login}>{_.CancelReset}</Link>
              </p>
              <p className="login-screen-footer-copyright">
                {_.FooterCopyright}
              </p>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(ForgotPassword);
